module.exports = __webpack_public_path__ + "img/II-28.98204ef8.svg";